import React from "react";

const userContext = React.createContext(); // Create a context object

export {
  userContext
};